<template>
<div class="chapter">
<div class="inner_page">
<table class="chapter-title-corner-decorations" width="100%"><tbody><tr><td class="chapter-title-corner-decoration-left-column"><div class="chapter-title-corner-decoration-left-column"><img alt="image" class="chapter-title-corner-decoration-left" src="d2d_images/chapter_title_corner_decoration_left.png"/></div></td><td class="chapter-title-corner-decoration-middle-column"> </td><td class="chapter-title-corner-decoration-right-column"><div class="chapter-title-corner-decoration-right-column"><img alt="image" class="chapter-title-corner-decoration-right" src="d2d_images/chapter_title_corner_decoration_right.png"/></div></td></tr></tbody></table><div class="chapter-title"><div class="chapter-title-decoration-above"><div class="chapter-title-decoration-above-inner"><img alt="image" class="chapter-title-decoration-above" src="d2d_images/chapter_title_above.png"/></div></div><h1 class="chapter-title">dedication</h1>
<div class="chapter-title-decoration-below"><div class="chapter-title-decoration-below-inner"><img alt="image" class="chapter-title-decoration-below" src="d2d_images/chapter_title_below.png"/></div></div></div><p class="first-in-chapter" style="text-align: justify"><span class="first-chapter-phrase"><span class="drop-cap">T</span>o the remarkably talented</span> people from Sparklesoup, who helped make this series come alive – THANK YOU!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?99effa1e